/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type authControl_settings = {
    readonly auth: {
        readonly integrations: {
            readonly local: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
            readonly oidc: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
            readonly google: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
            readonly facebook: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
        };
    };
    readonly " $refType": "authControl_settings";
};
export type authControl_settings$data = authControl_settings;
export type authControl_settings$key = {
    readonly " $data"?: authControl_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"authControl_settings">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRegistration",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "kind": "LinkedField",
            "name": "targetFilter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stream",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "authControl_settings",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Auth",
                "kind": "LinkedField",
                "name": "auth",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthIntegrations",
                        "kind": "LinkedField",
                        "name": "integrations",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "LocalAuthIntegration",
                                "kind": "LinkedField",
                                "name": "local",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OIDCAuthIntegration",
                                "kind": "LinkedField",
                                "name": "oidc",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "GoogleAuthIntegration",
                                "kind": "LinkedField",
                                "name": "google",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FacebookAuthIntegration",
                                "kind": "LinkedField",
                                "name": "facebook",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Settings",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '5c66b925c53fc2508d2a23cf5a43b0b9';
export default node;
